import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { OrderStatusesCountResponse, OrderStatusesInitials } from './_clientTypes';
import axios from "axios";
import { handleAxiosError } from '../../axios/handleAxiosError';
import { handleError } from '../../utils/handleError';
import { ODataParams } from '../_ODataTypes';
import { buildApiUrl } from '../../axios/urlCreator';
import { cachedGet } from '../../axios/responseCache';

const initialState: OrderStatusesInitials = {
    orderStatuses: null,
    loading: false,
    error: null
};

export const getOrderStatusesCount = createAsyncThunk<OrderStatusesCountResponse, ODataParams | void>(
    'client/getOrderStatusesCount',
    async (params, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params?.filter) queryParams.append('$filter', params.filter);
            if (params?.orderby) queryParams.append('$orderby', params.orderby);
            if (params?.top != null) queryParams.append('$top', params.top.toString());
            if (params?.skip != null) queryParams.append('$skip', params.skip.toString());

            return await cachedGet<OrderStatusesCountResponse>(buildApiUrl("client/orderStatusesCount", queryParams), 30_000);
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

const orderStatusesSlice = createSlice({
    name: 'orderStatuses',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOrderStatusesCount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getOrderStatusesCount.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.orderStatuses = action.payload;
            })
            .addCase(getOrderStatusesCount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});

export default orderStatusesSlice.reducer;
